import "../stylesheets/Servicios.css";
import heroBg from "../assets/hero/hero1.jpg";
import Navbar from "../components/navbar";

import aceroIcon from "../assets/categorias/acero.png";
import polvosIcon from "../assets/categorias/polvos.png";
import maderaIcon from "../assets/categorias/madera.png";
import electricoIcon from "../assets/categorias/electrico.png";
import herramientasIcon from "../assets/categorias/herramientas.png";
import ligerosIcon from "../assets/categorias/ligeros.png";
import plomeriaIcon from "../assets/categorias/plomeria.png";

function Servicios() {
  const categories = [
    { name: "Acero", img: aceroIcon, products: ["Varilla 3/8","Varilla 1/2","Varilla 5/8","Varilla 3/4",'Varilla 1"',"Alambre recocido","Alambrón","Clavo","Malla soldada 66/10","Malla soldada 66/66","Malla soldada 66/44","Malla soldada 66/88","Castillo 15x15","Castillo 15x20"] },
    { name: "Polvos", img: polvosIcon, products: ["Cemento CEMEX gris 50kg","Cemento CEMEX gris 25kg","Cemento CEMEX blanco 25kg","Cemento CEMEX blanco 50kg","Mortero CEMEX 50kg","Asfalto CEMEX en frío 25kg","Cemento CEMEX antihumedad 25kg","Cemento Apasco 50kg","Cemento Apasco 25kg","Estuco blanco 25kg","Yeso Máximo 40kg","Cal 25kg","Adhesivos Bexel","Boquillas Bexel","Adhesivos CREST","Boquillas CREST"] },
    { name: "Madera", img: maderaIcon, products: ["Triplay 12mm","Triplay 15mm","Triplay 18mm","Triplay Film Face 15mm","Triplay Film Face 18mm","Tablas","Barrotes","Polines",'Chaflán 1"',"Panel Aislasin"] },
    { name: "Material Eléctrico", img: electricoIcon, products: ["Cable","Contactos","Apagadores","Rocetas","Canaletas","Tubo Conduit","Conectores Conduit","Poliducto 1/2 100mts","Poliducto 3/4 100mts","Poliducto corrugado 50mts 1/2","Poliducto corrugado 50mts 3/4","Chalupas 2x4","Cajas 4x4","Cajas hexagonales","Guías para cable","Cable uso rudo"] },
    { name: "Herramientas", img: herramientasIcon, products: ["Pulidores","Rotomartillo","Esmeriladores","Taladros","Rotomartillos SDS","Lijadoras orbitales","Sierras circulares","Sierras eléctricas de mesa","Sierra caladora"] },
    { name: "Sistemas Ligeros", img: ligerosIcon, products: ["Casetón 15x20x40","Casetón 7x20x40","Casetón 10x20x40","Casetón 25x20x40","Postes metálicos","Canal de carga","Canal de amarre","Cinta de papel","Perfacinta","Ángulos","Tablaroca","Paneles Durock","Tablaroca antihumedad","Redimix","Pijas negras","Pijas framer"] },
    { name: "Plomería", img: plomeriaIcon, products: ["TuboPlus: Codos","Coples","Tubos","Conectores macho","Conectores hembra","Termofusora","Codo pipa","Válvulas","Tapón"] },
  ];

  return (
    <>
      <Navbar />

      <main className="servicios-page">
        <section className="hero-servicios">
          <div className="hero-content">
            <h1>Nuestros Servicios</h1>
            <p>Soluciones completas para tu obra, con calidad y rapidez.</p>
          </div>
        </section>

        <section className="servicios-intro" style={{ backgroundImage: `url(${heroBg})` }}>
          <div className="overlay">
            <h2>Materiales y soluciones para cada proyecto</h2>
            <p>Desde acero y polvos hasta herramientas y sistemas ligeros.</p>
          </div>
        </section>

        {categories.map(cat => (
          <section className="category-section" key={cat.name}>
            <div className="category-content">
              <img src={cat.img} alt={cat.name} className="category-icon" />
              <h2 className="category-title">{cat.name}</h2>

              <div className="product-cards">
                {cat.products.map((p,i)=>(
                  <div className="product-card" key={i}>
                    <div className="product-name">{p}</div>
                    <div className="product-desc">
                      Material de alta calidad para construcción profesional.
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        ))}
      </main>
    </>
  );
}

export default Servicios;
